import {Component, Input} from '@angular/core';
import {EventPreview} from "../../interfaces/event-preview";
import {forEach} from "lodash";

@Component({
  selector: 'brt-event-preview',
  templateUrl: './event-preview.component.html',
  styleUrls: ['./event-preview.component.scss']
})
export class EventPreviewComponent {

  eventPreview!: EventPreview;
  eventLabelClass = "";
  eventLabel = "";

  @Input("event-preview") set setEventPreview(value: EventPreview) {
    this.eventPreview = value;
    this.parseEventPreviewData();
  };

  parseEventPreviewData() {

    if(this.eventPreview.appointments.length === 0) {
      return
    }

    let bookableCount = 0;
    let isFull = false;

    this.eventPreview.appointments.forEach(appointment => {
      if(appointment.appointmentState === "ACTIVE") {
        bookableCount++;
      } else if(appointment.appointmentState === "FULL") {
        isFull = true;
      }
    });

    if(bookableCount > 0) {
      this.eventLabelClass = "green";
      this.eventLabel = "Termine verfügbar";
    } else if(isFull) {
      this.eventLabelClass = "red";
      this.eventLabel = "Ausgebucht"
    } else {
      // Handle Other Cases
    }

    this.eventPreview.appointments = this.eventPreview.appointments.filter((el) => el.appointmentState === "ACTIVE");

  }

  getAppointmentDatesText(appointments: {
    startTime: string;
    endTime: string;
    startDate: string;
    endDate: string;
    note: {
      link: string,
      firstname: string,
      lastname: string,
      phone: string,
      email: string,
      remark: string
    };
    bookableUntil: string;
    maxParticipants: number;
    appointmentType: string;
    appointmentState: string;
    bookingLink: string
  }[]) {

    let dateStrings: string[] = [];

    appointments.forEach(appointment => {
      let dateString = "";
      dateString += appointment.startDate;

      if(appointment.endDate.length) {
        dateString += ' - ' + appointment.endDate;
      }

      dateStrings.push(dateString);

    });

    return dateStrings.join(", ");

  }
}
